import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { ConstellationEntity } from ".";

// Static Storage Client
const dataClient = new StaticStorageClient();

// Cache
const cache = new Cache();

export async function getCachedConstellationEntity(constellation_id: number): Promise<ConstellationEntity | null> {
  let entity: any = await cache.get(constellation_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const system = await dataClient.get_constellation_by_id(constellation_id);
    if (system !== null) {
      entity = new ConstellationEntity(constellation_id, system);
      cache.put(constellation_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
